export default __webpack_public_path__ + "static/media/ayse.b33cb226.jpg";